import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { blurOnSelect: Boolean };

  static targets = [
    "cityInput",
    "addressInput",
    "postCodeInput",
    "regionInput",
    "countryCodeInput",
    "companyNameInput",
    "placeIdInput",
  ];

  onAutocompleteSelect(event) {
    this.placeIdInputTarget.value = event.detail?.place_id || "";

    if (event.detail?.name) {
      this.companyNameInputTarget.value = event.detail.name;
    }

    // Turbo restores focus after a refresh, which would reopen suggestions.
    if (this.blurOnSelectValue) event.target.blur();

    if (event.detail?.address) {
      this.fillAddressFields(event.detail);
    } else if (event.detail?.value) {
      this.loadAddress(event.detail.value).then((data) => {
        this.fillAddressFields(data);
      });
    }
  }

  fillAddressFields(data) {
    this.cityInputTarget.value = data.city || "";
    this.addressInputTarget.value = data.address || "";
    this.postCodeInputTarget.value = data.post_code || "";
    this.regionInputTarget.value = data.region || "";
    this.countryCodeInputTarget.value = data.country_code || "";

    this.countryCodeInputTarget.dispatchEvent(
      new Event("change", { bubbles: true }),
    );
  }

  loadAddress(placeId) {
    const url = new URL("/geocoded_address", window.location.origin);
    url.searchParams.set("place_id", placeId);

    return fetch(url).then((response) => response.json());
  }
}
